import React from "react";
import { Typography, Box } from "@mui/material";

const Unauthorized = () => (
  <Box sx={{ p: 4 }}>
    <Typography variant="h3" color="error">
      403 - Unauthorized
    </Typography>
    <Typography variant="body1">
      You do not have access to this page.
    </Typography>
  </Box>
);

export default Unauthorized;
